import * as React from "react";

import { Item } from "DistributedTaskControls/Common/Item";
import * as ReleaseDetailsViewAsync from "PipelineWorkflow/Scripts/ReleaseProgress/Release/ReleaseDetailsView";
import { LoadingComponent } from "DistributedTaskControls/Components/LoadingComponent";
import { getAsyncLoadedComponent } from "VSS/Flux/AsyncLoadedComponent";

const ReleaseDetailsViewItem = getAsyncLoadedComponent(
    ["PipelineWorkflow/Scripts/ReleaseProgress/Release/ReleaseDetailsView"],
    (ReleaseDetailsViewModule: typeof ReleaseDetailsViewAsync) => ReleaseDetailsViewModule.ReleaseDetailsView,
    () => <LoadingComponent className="tab-loading-component" />);

export class ReleasePropertiesItem implements Item {

    public getOverview(instanceId?: string): JSX.Element {
        return null;
    }

    public getDetails(): JSX.Element {
        return (
            <ReleaseDetailsViewItem />
        );
    }

    public getKey(): string {
        return "cd-release-properties";
    }
}
